import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '../../assets/config/config-svc.service';
import { SharedService } from '../shared/shared.service';
import { MapProfile, PsapMapProfile } from '../shared/models/mapProfile';

@Injectable({
    providedIn: 'root'
})
export class EsriMapService {

    constructor(public http: HttpClient, public sharedService: SharedService) {
    }

    getHeaders() {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'transactionId': this.sharedService.generateUUID()
            }),
            withCredentials: true
        };
    }

    public getPsapMapProfile(psapId: string): Observable<PsapMapProfile> {
        return this.http.get<any>(ConfigService.config.mapServiceUrl + '/map/psap/profile/' + psapId,
            this.getHeaders()).pipe(map(res => new PsapMapProfile(res)));
    }

    public createPsapMapProfile(payload: any): Observable<PsapMapProfile> {
        return this.http.post<any>(ConfigService.config.mapServiceUrl + '/map/psap-profile', payload,
            this.getHeaders()).pipe(map(res => new PsapMapProfile(res)));
    }

    public updatePsapMapProfile(id: string, payload: any): Observable<PsapMapProfile> {
        return this.http.put<any>(ConfigService.config.mapServiceUrl + '/map/psap-profile/' + id, payload,
            this.getHeaders()).pipe(map(res => new PsapMapProfile(res)));
    }

    public getMapProfiles(): Observable<MapProfile[]> {
        return this.http.get<any[]>(ConfigService.config.mapServiceUrl + '/map/profile',
            this.getHeaders()).pipe(map(res => (res ?? []).map(profile => new MapProfile(profile))));
    }
}
